import { render, staticRenderFns } from "./OrangeCommitments.vue?vue&type=template&id=58480cc5"
import script from "./OrangeCommitments.vue?vue&type=script&lang=js"
export * from "./OrangeCommitments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports